<template>
  <span
    v-if="noAvatar"
    class="no-avatar"
    :class="'bc' + user.peer_color_index"
    :data-content="user.first_name[0].toUpperCase()"/>
  <img
    v-else
    :src="avatarUrl"
    alt="Avatar"
    class="avatar">
</template>

<script>
  export default {
    name: 'Avatar',
    props: {
      user: Object,
    },
    computed: {
      noAvatar() {
        return !this.avatarUrl || !!this.avatarUrl.match(/no_avatar/)
      },
      avatarUrl() {
        return this.user.photos
          && this.user.photos[0]
          && this.user.photos[0][0]
          && this.user.photos[0][0].url
      },
    },
  }
</script>

<style scoped>
  .bc0 { background-color: #294659; } .tc0 { color: #294659; }
  .bc1 { background-color: #e56555; } .tc1 { color: #ca5650; }
  .bc2 { background-color: #f28c48; } .tc2 { color: #d87b29; }
  .bc3 { background-color: #8e85ee; } .tc3 { color: #7170d5; }
  .bc4 { background-color: #76c84d; } .tc4 { color: #50b232; }
  .bc5 { background-color: #5fbed5; } .tc5 { color: #55a8bd; }
  .bc6 { background-color: #549cdd; } .tc6 { color: #4e92cc; }
  .bc7 { background-color: #f2749a; } .tc7 { color: #e5638a; }
  .bc8 { background-color: #d1b04d; } .tc8 { color: #ae9038; }
</style>

<style scoped lang="stylus">
  .no-avatar
    display block
    position relative

    font-family Roboto, "Google Sans", Arial, sans-serif
    font-weight 500
    font-size 20px

    width 70px
    line-height 71px
    padding-top 100%

    border-radius 50%
    font-style normal
    text-align center
    text-transform uppercase
    color #fff
    overflow hidden

    &:before
      content attr(data-content)
      position absolute
      top 0
      left 0
      margin 0 auto
      width 100%

  .avatar
    width 70px
    border-radius 50%
</style>
